import { useEffect } from "react";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import { FiXCircle } from "react-icons/fi";
import { useAppDispatch } from "../../store/hooks";
import { cancelPendingOrder } from "../../store/smileDesign/paymentSlice";
import { getCreditUi } from "../../constants/creditPageTheme";

const PaymentCancelled = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const orderId = searchParams.get("order_id");
    const isPhotoRecolour = location.pathname.includes("photo-recolour");
    const t = getCreditUi(isPhotoRecolour ? "light" : "dark");
    const packagesPath = isPhotoRecolour
        ? "/dashboard/photo-recolour/packages"
        : "/dashboard/smiledesign/list-credits";
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (orderId) {
            dispatch(cancelPendingOrder(Number(orderId)));
        }
    }, [dispatch, orderId]);

    return (
        <div className={`${t.page} flex items-center justify-center min-h-[70vh]`}>
            <div className={`w-full max-w-lg ${t.card} p-5 sm:p-8 text-center`}>
                <div className="flex justify-center mb-6">
                    <div
                        className={`w-20 h-20 rounded-full flex items-center justify-center ${
                            isPhotoRecolour
                                ? "bg-red-50 border border-red-200"
                                : "bg-red-500/15 border border-red-500/30"
                        }`}
                    >
                        <FiXCircle className={`${t.danger} text-4xl`} />
                    </div>
                </div>

                <h1 className={`text-3xl font-bold ${t.body} mb-2`}>
                    Payment Cancelled
                </h1>

                <p className={`${t.muted} mb-8`}>
                    Your payment was not completed. No charges were made.
                </p>

                <Link
                    to={packagesPath}
                    className={`inline-block w-full py-3.5 text-center ${t.primaryBtn}`}
                >
                    Try Again
                </Link>
            </div>
        </div>
    );
};

export default PaymentCancelled;
